import React from "react";
import Edit from "../../../components/CRM/Edit";
import {
  LongTextInput,
  DisabledInput,
  ReferenceInput,
  TextInput,
  BooleanInput,
  required,
  email,
  TextField,
  TabbedForm,
  FormTab,
  translate,
  BooleanField,
  SingleFieldList,
  SelectInput,
  ReferenceField,
  ChipField,
  DateField,
  ReferenceArrayField
} from "admin-on-rest";
import DisabledInputLngLat from "../../../components/CRM/DisabledInput";
import {connect} from "react-redux";
import AutoComplete from "material-ui/AutoComplete";
import AutocompleteInput from "../../../components/CRM/AutocompleteInput";
import TimeInput from "../../../components/CRM/TimeInput";

import {
  validateStoreData,
  validateStoreMandatoryData,
  validateStoreUrl,
  validatePhone,
  validateHeadline,
  validateAbout,
  validateFacebookPage,
  validateWithoutPhone,
  validateWithoutWebInformation,
  validateSender,
  validateMarketingPartnerID,
  validateCustomerNumber
} from "./validations";
import {formStyle} from "./style";
import ReferenceSelectGrid from "../../../components/ReferenceSelectGrid";
import AddressPicker from "./AddressPicker";
import ReferenceArrayInput2 from "../../../components/ReferenceArrayInput2";
// import ReferenceManyField from "../../../components/ReferenceManyField";
import PromoFilter from "../Promos/PromoFilter";
import ActionBar from "../../../components/CRM/ActionBar/";

const StoreTitleBase = ({record, translate}) => {
  return (
    <span style={formStyle.titleStyle}>
      {translate("resources.stores.titleEdit")} {record ? `${record.name}` : ""}
    </span>
  );
};

const StoreTitle = translate(StoreTitleBase);

const WorkingHoursLabelBase = ({translate, label}) => (
  <div style={formStyle.textFieldContainer}>
    <p style={formStyle.textStyle}>
      <span>{translate(label)}:</span>
    </p>
  </div>
);

const WorkingHoursLabel = translate(WorkingHoursLabelBase);

const InputHeaderBase = ({translate, header, headerStyle}) => (
  <div style={headerStyle}>
    <span>{translate(header)}:</span>
  </div>
);

const InputHeader = translate(InputHeaderBase);

class StoreEditForm extends React.Component {
  state = {
    defaultAddress: {
      address: "",
      lat: "",
      lng: ""
    }
  };

  componentWillMount() {
    if (this.props.record && this.props.record.location === null) {
      this.props.record.location = Object.assign(this.state.defaultAddress);
    }
  }

  componentDidUpdate() {
    if (this.props.record && this.props.record.location === null) {
      this.state.defaultAddress.address !== "" &&
        this.state.defaultAddress.lat !== "" &&
        this.state.defaultAddress.lng !== "" &&
        (this.props.record.location = Object.assign(this.state.defaultAddress));
    } else if (this.props.record && this.props.record.location !== null) {
      this.state.defaultAddress.address !== "" &&
        (this.props.record.location.address = this.state.defaultAddress.address);
      this.state.defaultAddress.lat !== "" &&
        (this.props.record.location.lat = this.state.defaultAddress.lat);
      this.state.defaultAddress.lng !== "" &&
        (this.props.record.location.lng = this.state.defaultAddress.lng);
    }
  }

  setDefaultAddress = address => {
    this.setState({
      defaultAddress: {
        address: address.address,
        lat: address.lat,
        lng: address.lng
      }
    });
  };

  render() {
    const props = {...this.props};
    const record = {...props.record};

    const webInfoIsNotRequired =
      !record.headline ||
      record.headline === "" ||
      !record.about ||
      record.about === "" ||
      !record.working_hours ||
      record.working_hours === "";
    const phoneIsNotRequired = record.phone === "";

    const formValidation =
      record &&
      (phoneIsNotRequired && webInfoIsNotRequired
        ? validateStoreMandatoryData
        : phoneIsNotRequired && !webInfoIsNotRequired
        ? validateWithoutPhone
        : !phoneIsNotRequired && webInfoIsNotRequired
        ? validateWithoutWebInformation
        : validateStoreData);

    return (
      <Edit title={<StoreTitle />} {...props}>
        <TabbedForm validate={formValidation}>
          <FormTab
            label="resources.stores.titleTab1"
            elStyle={formStyle.tabStyle}
          >
            <ReferenceInput
              style={formStyle.tabStyle}
              label="resources.stores.inputs.storeOwner"
              source="partner_id"
              reference="partners"
              validate={required}
              sort={{field: "name", order: "ASC"}}
              allowEmpty
              filterToQuery={fullName => ({full_name_like: fullName})}
            >
              <AutocompleteInput
                optionText={record =>
                  `${record.first_name} ${record.last_name}`
                }
                options={{filter: AutoComplete.caseInsensitiveFilter}}
              />
            </ReferenceInput>
            <TextInput
              label="resources.stores.inputs.storeName"
              source="name"
            />
            <ReferenceInput
              style={formStyle.tabStyle}
              label="resources.stores.inputs.region"
              source="region_id"
              reference="regions"
              sort={{field: "name", order: "ASC"}}
              perPage={50}
              allowEmpty={false}
            >
              <SelectInput optionText="name" />
            </ReferenceInput>
            <TextInput
              label="resources.stores.inputs.sender"
              source="sms_sender"
              validate={validateSender}
            />
            <TextInput
              label="resources.stores.inputs.phoneNumber"
              source="phone"
              validate={validatePhone}
            />
            <TextInput
              label="resources.stores.inputs.email"
              source="email"
              type="email"
              validate={email}
            />
            <DisabledInput
              label="resources.stores.inputs.deviceSerialNumber"
              source="device_serial_number"
            />
            <BooleanInput
              label="resources.stores.inputs.hasQuestionnaire"
              source="has_questionnaire"
              defaultValue
              style={formStyle.inputStyle.booleanInput}
            />
            <TextInput
              label="resources.stores.inputs.storeUrlText"
              source="store_url"
              validate={validateStoreUrl}
            />
            <TextInput
              label="resources.stores.inputs.customerNumber"
              source="customer_number"
              validate={validateCustomerNumber}
            />
            <DisabledInput
              label="resources.stores.inputs.shortUrl"
              source="short_url"
              style={formStyle.inputStyle.lastInput}
            />
          </FormTab>
          <FormTab
            label="resources.stores.titleTab2"
            elStyle={formStyle.tabStyle}
          >
            <LongTextInput
              label="resources.stores.inputs.headline"
              source="headline"
              validate={validateHeadline}
              style={formStyle.inputStyle}
            />

            <LongTextInput
              label="resources.stores.inputs.about"
              validate={validateAbout}
              source="about"
              style={formStyle.inputStyle}
            />
            <TextInput
              label="resources.stores.inputs.phoneNumber"
              source="contact_info.phone_number"
              validate={validatePhone}
            />
            <TextInput
              label="resources.stores.inputs.email"
              source="contact_info.email"
              type="email"
              validate={email}
            />
            <InputHeader
              header="resources.stores.inputs.workingHours.header"
              headerStyle={formStyle.headerContainer}
              style={formStyle.tabStyle}
            />
            <WorkingHoursLabel
              label="resources.stores.inputs.workingHours.regular.days"
              style={formStyle.labelStyle}
            />
            <TimeInput
              label="resources.stores.inputs.workingHours.regular.start"
              source="working_hours.regular.start"
              locale="sv"
              style={formStyle.containerInput}
              working_hours={true}
            />
            <TimeInput
              label="resources.stores.inputs.workingHours.regular.end"
              source="working_hours.regular.end"
              locale="sv"
              working_hours={true}
            />
            <div style={formStyle.clearFloatContainer} />
            <WorkingHoursLabel
              label="resources.stores.inputs.workingHours.other.saturday"
              style={formStyle.labelStyle}
            />
            <TimeInput
              label="resources.stores.inputs.workingHours.other.start"
              source="working_hours.saturday.start"
              locale="sv"
              style={formStyle.containerInput}
              working_hours={true}
            />
            <TimeInput
              label="resources.stores.inputs.workingHours.other.end"
              source="working_hours.saturday.end"
              locale="sv"
              working_hours={true}
            />
            <div style={formStyle.clearFloatContainer} />
            <WorkingHoursLabel
              label="resources.stores.inputs.workingHours.other.sunday"
              style={formStyle.labelStyle}
            />
            <TimeInput
              label="resources.stores.inputs.workingHours.other.start"
              source="working_hours.sunday.start"
              locale="sv"
              style={formStyle.containerInput}
              working_hours={true}
            />
            <TimeInput
              label="resources.stores.inputs.workingHours.other.end"
              source="working_hours.sunday.end"
              locale="sv"
              working_hours={true}
            />
            <div style={formStyle.clearFloatContainer} />
            <BooleanInput
              label="resources.stores.inputs.workingHours.holiday_differ"
              source="working_hours.holiday_differ"
              defaultValue
              style={formStyle.inputStyle.longBooleanInput}
            />
            <div style={formStyle.clearFloatContainer} />
            <InputHeader
              header="resources.stores.inputs.address"
              headerStyle={formStyle.headerContainer}
              style={formStyle.labelStyle}
            />
            <DisabledInput
              label=""
              source="location.address"
              defaultValue={this.state.defaultAddress.address}
              options={{fullWidth: true}}
              style={formStyle.addressInputStyle}
            />
            <div style={formStyle.clearFloatContainer} />

            <AddressPicker
              setDefaultAddress={this.setDefaultAddress}
              address={this.state.defaultAddress}
              style={formStyle.pickerStyle}
            />
            <InputHeader
              header="resources.stores.inputs.lat"
              headerStyle={formStyle.latLngContainer}
              style={formStyle.labelStyle}
            />

            <DisabledInputLngLat
              label=""
              source="location.lat"
              defaultValue={this.state.defaultAddress.lat}
              customUnderlineDisabledStyle={formStyle.latLngInputStyle}
              elStyle={formStyle.lanLngStyle}
            />

            <InputHeader
              header="resources.stores.inputs.lng"
              headerStyle={formStyle.latLngContainer}
              style={formStyle.labelStyle}
            />

            <DisabledInputLngLat
              label=""
              source="location.lng"
              defaultValue={this.state.defaultAddress.lng}
              customUnderlineDisabledStyle={formStyle.latLngInputStyle}
              elStyle={formStyle.lanLngStyle}
            />

            <div style={formStyle.clearFloatContainer} />
            <TextInput
              label="resources.stores.inputs.facebookPage"
              source="facebook_page"
              validate={validateFacebookPage}
              options={{fullWidth: true}}
              style={formStyle.faceBookInputStyle}
            />
          </FormTab>

          {this.props.configuration.promos &&
            this.props.configuration.promos.enabled === true && (
              <FormTab label="resources.stores.titleTab3">
                <ReferenceArrayInput2
                  reference="promos"
                  source="promo_ids"
                  location={props.location}
                  actions={
                    <ActionBar
                      createButton={false}
                      deleteButton={false}
                      withActionMenu={false}
                    />
                  }
                  filters={<PromoFilter isNested={true} />}
                >
                  <ReferenceSelectGrid
                    options={{
                      multiSelectable: true,
                      selectable: true
                    }}
                    headerOptions={{
                      adjustForCheckbox: true,
                      displaySelectAll: true,
                      enableSelectAll: true
                    }}
                    bodyOptions={{
                      displayRowCheckbox: true,
                      deselectOnClickaway: false,
                      showRowHover: true
                    }}
                    rowOptions={{selectable: true}}
                  >
                    <TextField
                      label="resources.promos.fields.promoName"
                      source="name"
                    />
                    <DateField
                      label="resources.promos.fields.validFrom"
                      source="valid_from"
                    />
                    <DateField
                      label="resources.promos.fields.validTo"
                      source="valid_to"
                    />

                    <ReferenceArrayField
                      label="resources.promos.fields.industry"
                      source="industries_id"
                      reference="industries"
                    >
                      <SingleFieldList>
                        <ChipField source="name" />
                      </SingleFieldList>
                    </ReferenceArrayField>

                    <ReferenceField
                      label="resources.promos.fields.marketingPartner"
                      source="marketing_partner_id"
                      reference="marketing_partners"
                      linkType={false}
                    >
                      <TextField source="name" />
                    </ReferenceField>

                    <BooleanField
                      label="resources.promos.fields.active"
                      source="active"
                    />
                  </ReferenceSelectGrid>
                </ReferenceArrayInput2>
              </FormTab>
            )}

          <FormTab
            label="resources.stores.titleTab4"
            elStyle={formStyle.tabStyle}
          >


            <InputHeader
                header="resources.stores.inputs.marketingPartner.mrGreen.name"
                headerStyle={formStyle.headerContainer}
                style={formStyle.headerSectionStyle}
            />
            <div style={formStyle.clearFloatContainer} />
            <TextInput
                label="resources.stores.inputs.marketingPartner.mrGreen.marketingSourceId"
                source="extra.mrgreen.marketing_source_id"
                validate={validateMarketingPartnerID}
            />


            <InputHeader
              header="resources.stores.inputs.marketingPartner.william_hill.name"
              headerStyle={formStyle.headerContainer}
              style={formStyle.headerSectionStyle}
            />
            <div style={formStyle.clearFloatContainer} />
            <TextInput
              label="resources.stores.inputs.marketingPartner.william_hill.pid"
              source="extra.william_hill.pid"
            />



            <InputHeader
                header="resources.stores.inputs.marketingPartner.cashbacker.name"
                headerStyle={formStyle.headerContainer}
                style={formStyle.headerSectionStyle}
            />
            <div style={formStyle.clearFloatContainer} />
            <BooleanInput
              label="resources.stores.inputs.giftcard"
              source="extra.cashbacker.gift_card_enabled"
              defaultValue
              style={formStyle.inputStyle.booleanInput}
            />


            <InputHeader
                header="resources.stores.inputs.marketingPartner.storemarket.name"
                headerStyle={formStyle.headerContainer}
                style={formStyle.headerSectionStyle}
            />
            <div style={formStyle.clearFloatContainer} />
            <BooleanInput
                label="resources.stores.inputs.giftcard"
                source="extra.storemarket.gift_card_enabled"
                defaultValue
                style={formStyle.inputStyle.booleanInput}
            />

            <InputHeader
              header="resources.stores.inputs.marketingPartner.betfair.name"
              headerStyle={formStyle.headerContainer}
              style={formStyle.headerSectionStyle}
            />
            <div style={formStyle.clearFloatContainer} />
            <TextInput
              label="resources.stores.inputs.marketingPartner.betfair.pid"
              source="extra.betfair.pid"
            />

          </FormTab>
        </TabbedForm>
      </Edit>
    );
  }
}

const mapStateToProps = (state, props) => ({
  id: decodeURIComponent(props.match.params.id),
  configuration: state.configuration,
  record: state.admin.resources[props.resource]
    ? state.admin.resources[props.resource].data[
        decodeURIComponent(props.match.params.id)
      ]
    : null
});

export default connect(mapStateToProps)(translate(StoreEditForm));



// WEBPACK FOOTER //
// ./src/containers/CRM/Stores/StoreEditForm.js